import { useState } from "react";
import { cn } from "@/lib/utils";

interface ImageWithFallbackProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallback?: React.ReactNode;
  containerClassName?: string;
}

export function ImageWithFallback({
  src,
  alt = "",
  fallback,
  containerClassName,
  className,
  ...props
}: ImageWithFallbackProps) {
  const [error, setError] = useState(false);

  if (!src || error) {
    return (
      <div
        className={cn(
          "flex items-center justify-center bg-deepOcean/10 text-deepOcean/30",
          containerClassName
        )}
        role="img"
        aria-label={alt || "Imagem indisponível"}
      >
        {fallback || <span className="font-playfair text-4xl font-bold">PF</span>}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setError(true)}
      loading="lazy"
      decoding="async"
      {...props}
    />
  );
}
